import React, { useState } from 'react';
import './TaskForm.css';

function ProjectForm({ onSubmit, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((current) => ({
      ...current,
      [name]: value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    onSubmit({
      name: formData.name.trim(),
      description: formData.description.trim()
    });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content form-container">
        <h2>Crear Proyecto</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group full-width">
            <input
              type="text"
              name="name"
              placeholder="Nombre del proyecto"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group full-width">
            <textarea
              name="description"
              placeholder="Descripción opcional"
              value={formData.description}
              onChange={handleChange}
            />
          </div>

          <div className="form-buttons">
            <button type="submit" className="modal-primary-button">
              Crear proyecto
            </button>

            <button
              type="button"
              className="modal-secondary-button"
              onClick={onClose}
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ProjectForm;
